import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 活动页信息接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814100
export const voteInfo = createAsyncThunk(
  'bigr_voting_competion_info',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/bigr_voting_competion_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data?.data
  }
)

// 排行榜数据接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814252
export const voteRank = createAsyncThunk(
  'bigr_voting_competion_rank_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/bigr_voting_competion_rank_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        act_no: 'turkeyAnnualVote',
      }
    )
    return resp.data?.data
  }
)

// 参赛用户搜索接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814230
export const searchUser = createAsyncThunk(
  'bigr_voting_competion_search_user',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/bigr_voting_competion_search_user',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        act_no: 'turkeyAnnualVote',
      }
    )
    return resp.data?.data
  }
)

// 投票接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814290
export const voteUser = createAsyncThunk(
  'bigr_voting_competion_vote',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/bigr_voting_competion_vote', {
      ...store.getState().env.deviceinfo,
      ...p,
      act_no: 'turkeyAnnualVote',
    })
    return resp.data?.data
  }
)

export enum STAGESTATUS {
  未开始 = 1,
  开始 = 2,
  已结束 = 3,
}

const initialState: {
  home_page_info?: {
    stage_id?: number
    status?: STAGESTATUS
    start_time?: string
    end_time?: string
    recommendation_list?: {
      id: number
      name: string
      zy_id: string
      avatar: string
      gender: number
    }[] // 保送名单
    prize_list?: {
      id: number
      activity_id: number
      view_icon: string
      toast_name: string
      reward_type: number
      reward_string: string
      count: number
    }[][] // 奖励列表
    user_data?: {
      can_vote: boolean
      tickets: number // （用户票数）
      is_participant: boolean // （是否本阶段的参赛者）
      is_today_first_login: boolean // （是否当天首次登录）
      rank_info: {
        data: number // （当前用户距离上一名的分数）
      }
    }
    countdown?: number
  }
} = {
  home_page_info: {},
}

export const YearVote2023Slice = createSlice({
  name: 'YearVote2023',
  initialState,
  reducers: {
    // setStatus: (state, action: PayloadAction<number>) => {
    //   Object.assign(state, {
    //     annual_reward_status: action.payload,
    //   })
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(voteInfo.fulfilled, (state, action) => {
      Object.assign(state?.home_page_info, action.payload)
    })
  },
})

export default YearVote2023Slice.reducer
export const YearVote2023SliceActions = YearVote2023Slice.actions
